import React from "react";
import Header from "../../layout/Header";
import BottomFooterBar from "../../layout/BottomFooterBar";
import UpdateIncomeContent from "./UpdateIncomeContent";
import { Step } from "../../../common/types";

const INCOME_STEP_ID = 4;

interface IncomeOnlyPageProps {
  userName: string;
  lastName: string;
  userEmail: string;
  incomeStep: Step | undefined;
  markStepAsCompleted: (stepId: number) => void;
  onComplete: () => void;
  onLogoClick: () => void;
}

/**
 * Stripped-down layout for users routed straight to income verification
 * (ApplicationStatusDto.isFromIncome === true). Intentionally omits
 * ChooseLoanPage, Sidebar, QuickJumpNav, and MobileBottomNav — only
 * Header + the income form + footer are shown, regardless of applicant
 * vs co-applicant.
 */
const IncomeOnlyPage: React.FC<IncomeOnlyPageProps> = ({
  userName,
  lastName,
  userEmail,
  incomeStep,
  markStepAsCompleted,
  onComplete,
  onLogoClick,
}) => {
  const visibleSteps = incomeStep ? [incomeStep] : [];

  return (
    <div className="min-h-screen flex flex-col">
      <Header
        userName={userName}
        lastName={lastName}
        onMenuToggle={() => {}}
        isMobileMenuOpen={false}
        currentViewedStepId={INCOME_STEP_ID}
        onLogoClick={onLogoClick}
        userEmail={userEmail}
        showMenuButton={false}
      />

      <div className="flex-grow w-full max-w-screen-2xl mx-auto px-2 sm:px-4 lg:px-6 xl:px-8 py-4">
        <UpdateIncomeContent
          onNextStep={onComplete}
          mainContentClassName="flex-grow md:h-full"
          markStepAsCompleted={markStepAsCompleted}
          currentStepId={INCOME_STEP_ID}
          visibleSteps={visibleSteps}
          showSubmitButton={false}
        />
      </div>

      <BottomFooterBar />

      <footer className="hidden md:block text-center pt-3 pb-[calc(0.75rem+env(safe-area-inset-bottom))] text-gray-500 text-base bg-gray-50">
        &copy; {new Date().getFullYear()} Veros Credit. All rights reserved.
      </footer>
    </div>
  );
};

export default IncomeOnlyPage;
